import { render, staticRenderFns } from "./socialOld.vue?vue&type=template&id=6e5b551f&scoped=true&"
import script from "./socialOld.vue?vue&type=script&lang=js&"
export * from "./socialOld.vue?vue&type=script&lang=js&"
import style0 from "./socialOld.vue?vue&type=style&index=0&id=6e5b551f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5b551f",
  null
  
)

export default component.exports